<div class="
    black-checkbox
    new-table-style example-container-measureimpactdefinitions">

  <table mat-table
    [dataSource]="dataSource"
    [trackBy]="trackByMeasureId"
    multiTemplateDataRows
    matSort
    class="mat-elevation-z8 mat-table-custom" id="MeasureImpactTable">

    <ng-container matColumnDef="arrow">
      <th mat-header-cell *matHeaderCellDef>
        @if (!isAllCollapsed) {
          <mat-icon (click)="collapseOrExpandAll()">expand_more</mat-icon>
        }
        @if (isAllCollapsed) {
          <mat-icon (click)="collapseOrExpandAll()">expand_less</mat-icon>
        }
      </th>
      <td mat-cell *matCellDef="let element" (click)="pushPopElement(element)">
        <ng-container>
          @if (checkExpanded(element)) {
            <mat-icon>
              expand_less
            </mat-icon>
          } @else {
            <mat-icon matTooltip="Show Action Items">
              expand_more
            </mat-icon>
          }
        </ng-container>
      </td>
    </ng-container>

    <ng-container matColumnDef="ItemNo">
      <th mat-header-cell *matHeaderCellDef>Measure</th>
      <td mat-cell *matCellDef="let measure">
        <p [innerHTML]="measure.ItemNo"></p>
      </td>
    </ng-container>

    <ng-container matColumnDef="Name">
      <th mat-header-cell *matHeaderCellDef> Name </th>
      <td mat-cell *matCellDef="let measure">
        <p [innerHTML]="measure.Name | bold: dataSource.filter"></p>
      </td>
    </ng-container>

    <ng-container matColumnDef="Description">
      <th mat-header-cell *matHeaderCellDef> Description </th>
      <td mat-cell *matCellDef="let measure">
        <p [innerHTML]="measure.Description | bold: dataSource.filter"></p>
      </td>
    </ng-container>


    <ng-container matColumnDef="Kpi">
      <th mat-header-cell *matHeaderCellDef> KPI </th>
      <td mat-cell *matCellDef="let measure">
        <p [innerHTML]="measure.KpiName"></p>
      </td>
    </ng-container>

    <ng-container matColumnDef="KpiUnit">
      <th mat-header-cell *matHeaderCellDef> KPI Unit </th>
      <td mat-cell *matCellDef="let measure">
        <p [innerHTML]="measure.KpiUnit"></p>
      </td>
    </ng-container>

    <ng-container matColumnDef="ReportingType">
      <th mat-header-cell *matHeaderCellDef> Reporting Type </th>
      <td mat-cell *matCellDef="let measure">
        <p [innerHTML]="measure.ReportingType"></p>
      </td>
    </ng-container>

    <ng-container matColumnDef="KpiDescription">
      <th mat-header-cell *matHeaderCellDef> KPI Description </th>
      <td mat-cell *matCellDef="let measure">
        <p [innerHTML]="measure.KpiDescription"></p>
      </td>
    </ng-container>

    <ng-container matColumnDef="impactHistory">
      <th mat-header-cell *matHeaderCellDef>Change Log</th>
      <td mat-cell *matCellDef="let measure" class="notEditable">
        <compact-history-button
          [item]="measure"
          buttonText="Get History"
          (historyClick)="onImpactHistoryDetail($event)">
        </compact-history-button>
      </td>
    </ng-container>

    <!-- Expanded Content Column - The detail row is made up of this one column that spans across all columns -->
    <ng-container matColumnDef="actionitems">
      <td mat-cell *matCellDef="let measure" [attr.colspan]="columnsToDisplay.length">
        <div [@detailExpand]="checkExpanded(measure) ? 'expanded' : 'collapsed'"
          id="{{measureImpactTargetSubtableId}}">
          <p style="color:white">{{fiscalYearDisplay}}</p>
          <table mat-table
            [dataSource]="measure.Subtables[measure.SelectedBreakdown]"
            [trackBy]="trackBySubitem"
            class="mat-subtable-custom" id="MeasureImpactTargetSubtableAllPeriods">

            <ng-container matColumnDef="item">
              <th mat-header-cell *matHeaderCellDef> </th>
              <td mat-cell *matCellDef="let item; index as i;">
                <p [innerHTML]="item.item"></p>
              </td>
            </ng-container>
            @for (period of periods; track period; let i = $index) {
              <ng-container [matColumnDef]="period.key">
                <th mat-header-cell *matHeaderCellDef> {{ period.label }} </th>
                <td mat-cell *matCellDef="let item; index as j;">
                  @if (item.item !== hardcodedTargetValueLabel) {
                    <p
                    [innerHTML]="formatNumber(item[period.key])" [style.display]="isEditableFieldEnabled(item.item) ? 'none' : 'block'"></p>
                  }
                  @if (item.item === hardcodedTargetValueLabel) {
                    <p
                    [innerHTML]="formatNumber(item[period.key], hardcodedDecimals)" [style.display]="isEditableFieldEnabled(item.item) ? 'none' : 'block'"></p>
                  }
                  @if (item.item === targetValueLabel) {
                    <p
                    [innerHtml]="formatNumber(getTarget(measure.Subtables, measure.SelectedBreakdown, period.key))"></p>
                  }
                  @if (item.item === deltaActualToTargetLabel) {
                    <p
                    [innerHtml]="formatNumber(getDeltaTarget(measure.Subtables, measure.SelectedBreakdown, period.key))"></p>
                  }
                  <input matInput type="number"
                    [ngClass]="{'hidden': !isEditableFieldEnabled(item.item) }"
                    (keydown)="validateHardcodedTarget($event, measure, period.key, item.item)"
                    (ngModelChange)="onChange(measure, period.id, item['MeasureTarget' + period.key + 'Id'], $event, item.item, item)"
                    [(ngModel)]="item[period.key]"
                    (blur)="onInputBlur(item, period.key, measure.KpiUnit)">
                  </td>
                </ng-container>
              }
              <ng-container matColumnDef="Total">
                <th mat-header-cell *matHeaderCellDef> {{ getTotalHeaderLabel(measure) }} </th>
                <td mat-cell *matCellDef="let item; index as i;">
                  <p [innerHTML]="item.Total" [style.display]="'block'"></p>
                  @if (item.item === this.targetValueLabel) {
                    <p
                    [innerHtml]="getSumTarget(measure)"></p>
                  }
                  @if (item.item === this.hardcodedTargetValueLabel) {
                    <p
                    [innerHtml]="getSumHardcodedTarget(measure)"></p>
                  }
                  @if (item.item === this.targetLabel) {
                    <p
                    [innerHtml]="getSumPercentageTarget(measure)"></p>
                  }
                  @if (item.item === this.deltaActualToTargetLabel) {
                    <p
                    [innerHtml]="getSumActualToTarget(measure)"></p>
                  }
                </td>
              </ng-container>

              <tr mat-header-row class="subtableheader" *matHeaderRowDef="measure.subColumnsToDisplay"></tr>
              <tr mat-row *matRowDef="let item; let i2 = index; columns: measure.subColumnsToDisplay;" class="subitem"
                [class.editable]="getIsEditModeEnabled() && (item.item === this.targetLabel || item.item === this.hardcodedTargetValueLabel)"
              [class.noneditable]="getIsEditModeEnabled() && item.item !== this.targetLabel && item.item !== this.hardcodedTargetValueLabel"></tr>
            </table>
          </div>
        </td>
      </ng-container>
      <tr mat-header-row class="tableheader" *matHeaderRowDef="columnsToDisplay"></tr>
      <tr mat-row *matRowDef="let measure; let i = dataIndex; columns: columnsToDisplay;"
        class="item">
      </tr>
      <tr mat-row *matRowDef="let row; columns: ['actionitems']" class="row-subitem"></tr>
    </table>
  </div>

